import React, { useCallback, useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";
import * as Style from "../../../modules/assests_new/asset-listing/styles/Asset-Listing";
import tableimg from "../../../../assets/images/big/camera.png";
import Loader from "../../../../components/styled-components/loader/loader";
import { Modal, Form, Button } from "antd";
import swal from "sweetalert";
import { Link, useHistory } from "react-router-dom";
import addIcon from "../../../../assets/SVGs/android-chrome-512x512.png";
import addIcon1 from "../../../../assets/images/DeathModuleNew/addIcon.png";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  saveActiveProperty,
  saveAllProperties,
} from "../../../../redux/slices/propertiesSlice";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
function LiabilityListing(props) {
  const [allProperties, setAllProperties] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const [activeRoom, setActiveRoom] = useState();
  const [allItems, setAllItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showItemAdd, setShowItemAdd] = useState(false);
  const history = useHistory();

  const { propertiesInfo, roomsInfo, itemsInfo } = useSelector(
    (state) => state.rootReducer
  );
  const dispatch = useDispatch();
  const updateInventory = useCallback((item) => {}, []);
  const updateProperties = useCallback(() => {
    airplaneReport();
  }, []);

  const { module } = useParams();

  React.useEffect(() => {
    airplaneReport();
  }, []);
  let propertiesList = [];
  let roomsList = [];
  let rooms = [];

  async function airplaneReport() {
    try {
      setIsLoading(true);
      setAllProperties([]);
      let airplane = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      setIsLoading(false);
      console.log("new report");

      // propertiesList=airplane&&
      propertiesList =
        airplane &&
        airplane.records.map((properties) => ({
          id: properties.id,
          Owner: properties.Owner,
          module: properties.module,
          type: properties.type ? properties.type : 0,
          subType: properties.subType ? properties.subType : 0,
          img:
            properties.image 
              ? properties.image
              : tableimg,
          name: properties.NameofAsset,
          total: properties.total ? properties.total : 0,
          "Account Type/Titled": properties["Account Type/Titled"],
          loanType: properties["Type of Loan"],
          loanAmount: properties["Initial Loan Amount"],
          nickName: properties["Nickname of Liabilities"] || properties["Nickname of Credit"],
          interestRate: properties["Interest Rate"] ? properties["Interest Rate"] : properties["Interest Rate (or APR%)"] ? properties["Interest Rate (or APR%)"] : null,
          maturityDate: properties["Maturity Date"] ? properties["Maturity Date"]  : null,
          monthlyPayment: properties["Monthly Payment"] ? properties["Monthly Payment"]  : null,
          loanBalance:properties["Loan Balance"] ? properties["Loan Balance"] : properties["Credit Balance"] ? properties["Credit Balance"] : null,
          accountNumber:properties["Account Number"] ? properties["Account Number"] : null

        }));
      setAllProperties(propertiesList);
      // dispatch(saveAllProperties(propertiesList));
    } catch (error) {
      console.log("e ", error);
    }
  }

  function handleDelete(event, item, type) {
    console.log(
      "event",
      event,
      "item",
      item,
      "active Item=>",
      activeItem,
      activeRoom
    );
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want to Delete this?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then(async (doDelete) => {
      setIsLoading(true);
      doDelete &&
        (await MODULE_API.removeClientModule({
          clientModules: [item.id],
        }));
      if (type == "property") {
        updateProperties();
        setActiveItem("");
        return;
      } else if (type == "room") {
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
        setAllItems("");
        setShowItems(false);
        setShowItemAdd(false);
      } else {
        await MODULE_API.getRecordTotal(activeRoom, {
          attributes: ["currentValue"],
        });
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
      }
      updateInventory(activeItem);
    });
  }

  function deletePost(id) {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setIsLoading(true);

        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          airplaneReport();
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      }
    });
  }
  function handleEdit(event, item, type) {
    console.log(
      "event",
      event,
      "item",
      item,
      "active Item=>",
      activeItem,
      activeRoom
    );
    history.push(
      `/liabilities_credit_new/attributes/${item.module}/${item.id}`
    );
    // history.push("/assets_edit/" + item.id);
    // `/assets_new/attributes/${record.module}/${record.id}`
    // swal({
    //     title: "Are you sure?",
    //     text: "Are you sure that you want to Delete this Property?",
    //     icon: "warning",
    //     dangerMode: true,
    //     buttons: true,
    // }).then(async (doDelete) => {
    //     setIsLoading(true);
    //     doDelete &&
    //         (await MODULE_API.removeClientModule({
    //             clientModules: [item.id],
    //         }));
    //     if (type == "property") {
    //         updateProperties();
    //         setActiveItem("");
    //         return;
    //     } else if (type == "room") {
    //         await MODULE_API.getRecordTotal(activeItem.id, {
    //             attributes: ["total"],
    //         });
    //         setAllItems("");
    //         setShowItems(false);
    //         setShowItemAdd(false);
    //     } else {
    //         await MODULE_API.getRecordTotal(activeRoom, {
    //             attributes: ["currentValue"],
    //         });
    //         await MODULE_API.getRecordTotal(activeItem.id, {
    //             attributes: ["total"],
    //         });
    //     }
    //     updateInventory(activeItem);
    // });
  }

  function moneyFormatter(value) {
    console.log("value", allProperties);
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    let result = formatter.format(value);
    console.log("Money :: ", result);
    return result;
  }

  function handleViewitem(event, item, type) {
    history.push(
      `/liabilities_credit_new/attributes/${item.module}/${item.id}/view`
    );
  }
  return (
    <div style={{position:"relative"}}>
      <Style.Main >
        <Style.Cards
          style={{
            borderBottom:
            allProperties && allProperties.length > 0 ? "1px solid #F0F0F0" : "none",
          }}>
          <Style.SubCards
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}>
            <Style.CardsHead>
              <h3
                style={{
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  fontSize: "20px",
                }}>
               {module==="Real Estates" ? "Real Estate" : module}
              </h3>
            </Style.CardsHead>
            <Style.PropertyAdd
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}>
              <div style={{ marginRight: "1rem" }}>
                <h3 style={{ fontFamily: "Poppins", fontSize: "20px" }}>
                  Add {module==="Real Estates" ? "Real Estate" : module}
                </h3>
              </div>

              <Link
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                to={`/liabilities_credit_new/attributes/${module}`}>
                <div
                  className="upload"
                  style={{ width: "28px", height: "28px" }}>
                  <img
                    src={addIcon1}
                    width={12}
                    height={12}
                    style={{ width: "16px", height: "16px" }}
                    alt="addicon"></img>
                </div>
                {/*<Style.AddBtn>
                  <img src={addIcon} />
                 
                </Style.AddBtn> */}
              </Link>
            </Style.PropertyAdd>
          </Style.SubCards>
          <Style.CardsMain
            style={{
              justifyContent: allProperties && allProperties.length > 0 ? "start" : "center",
              padding: "8px",
              gap: "1rem",
            }}>
            {/* {allProperties? allProperties.length >0: <p>No record found.</p>} */}
            {allProperties && allProperties.length > 0 ? (
              allProperties.map((item, index) => (
                <Style.Card
                  key={index}
                  //   onClick={() => fetchRoom(item)}

                  active={item.id == activeItem}>
                  {console.log("item.image", item)}
                  <div style={{ overflow: "hidden", padding: "1rem", textAlign:"center" }}>
                    <Style.Img src={item.img} style={{width:"auto"}} />
                  </div>

                  <Style.PropertyCardDetails>
                    <div style={{ paddingTop: "1rem", overflow: "hidden" }}>
                      <Style.PropertyCardH3>{module==="Real Estates" ? (item.nickName ? item.nickName : "N/A") :item.nickName ? item.nickName : "N/A"}</Style.PropertyCardH3>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div className="custom-field-alignments-icons">
                        <Button
                          onClick={(e) => {
                            handleEdit(e, item, "property");
                          }}
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="edit"></Button>
                      </div>
                      <div className="custom-field-alignments-icons">
                        <Button
                          onClick={(e) => {
                            handleViewitem(e, item, "property");
                          }}
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="eye"></Button>
                      </div>

                      <div className="custom-field-alignments-icons">
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="delete"
                          onClick={(e) => {
                            handleDelete(e, item, "property");
                            deletePost(item.id);
                          }}></Button>
                      </div>
                    </div>
                  </Style.PropertyCardDetails>
                  <Style.Desc
                    style={{
                      paddingInline: "1rem",
                      borderBottom: "1px solid #F0F0F0",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                      }}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#8B8D97",
                            }}>
                            {module==="Real Estates" ? "Interest Rate:" :"Interest Rate:"}
                          </p>
                        </div>
                        {console.log("iiiiiiii",item)}
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "black",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "500",
                              // paddingLeft: "0.4rem",
                            }}>
                            {module==="Real Estates" ? (item.interestRate ? item.interestRate +"%" : "N/A")  :(item.interestRate ? item.interestRate +"%" : "N/A")}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#8B8D97",
                            }}>
                            {module==="Real Estates" ? "Account Number:" :"Account Number:"}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "500",
                              // paddingLeft: "0.4rem",
                            }}>
                            {module==="Real Estates" ? (item.accountNumber ? "****" + item.accountNumber : "N/A") :(item.accountNumber ? "****" + item.accountNumber : "N/A")}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#8B8D97",
                          }}>
                          {module==="Real Estates" ? "Monthly Payment:" :"Monthly Payment:"}
                        </p>
                      </div>
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            // paddingLeft: "0.4rem",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}>
                          {module==="Real Estates" ? (item.monthlyPayment ? moneyFormatter(item.monthlyPayment) : "N/A") :(item.monthlyPayment ? moneyFormatter(item.monthlyPayment) : "N/A")}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex", width: "90%" }}></div>
                  </Style.Desc>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingInline: "1rem",
                    }}>
                    <div>
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#8B8D97",
                          margin:"8px 0px"
                        }}>
                        {module==="Real Estates" ? "Balance:" :"Balance:"}

                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          // paddingLeft: "0.4rem",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}>
                        {module==="Real Estates" ? (item.loanBalance ? moneyFormatter(item.loanBalance) : "$ 0") :(item.loanBalance ? moneyFormatter(item.loanBalance) : "$ 0")}
                      </p>
                    </div>
                  </div>
                  {/*  <Style.Counts1>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Style.Sign1>
                        <h3 style={{ color: "white", paddingTop: "0.5rem" }}>
                          $
                        </h3>
                      </Style.Sign1>
                      <div
                        style={{
                          width: "90%",
                          display: "flex",
                          justifyContent: "center",
                          paddingRight: "1rem",
                        }}
                      >
                        <h3
                          style={{
                            paddingTop: "0.5rem",
                            color: "#2a3da3",
                            fontWeight: "bold",
                          }}
                        >
                          {item.loanAmount
                            ? moneyFormatter(item.loanAmount)
                            : "$ 0"}
                        </h3>
                      </div>
                    </div>
                          </Style.Counts1> */}
                </Style.Card>
              ))
            ) : (
              <h1 style={{marginTop:"6rem"}}>No Items to Display for this Asset Allocation.</h1>
            )}
          </Style.CardsMain>
        </Style.Cards>
      </Style.Main>
      <div>
        <Modal
          width={"58rem"}
          visible={isModal}
          footer={null}
          // onCancel={handleModalCancel}
          // style={{ width: showUpdateItem && "fit-content" }}
          bodyStyle={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 200px)",
          }}></Modal>
      </div>
      <NewLoader isLoading={isLoading}/>
    {/*  <Loader isLoading={isLoading} /> */}
    </div>
  );
}

export default LiabilityListing;
